import RegisterScreen from "./RegisterScreen";

export default RegisterScreen;
